import { useState } from 'react'
import { usePromptContent, usePromptDrafts, usePromptSlots } from './queries'
import { PromptDiff } from './prompt-diff'
import { PromptDrafts } from './prompt-drafts'
import { SLOT_LABELS, slotKey } from './prompt-labels'
import { Select } from '@lunary/ui-web/select'
import styles from './studio.module.css'

export function Prompts() {
  const slots = usePromptSlots()
  const drafts = usePromptDrafts()
  const [key, setKey] = useState('persona')
  const [version, setVersion] = useState(0)
  const [compare, setCompare] = useState('')

  const slot = slots.data?.slots.find((s) => slotKey(s.scope, s.name) === key)
  const shown = version || slot?.active || 0
  const base = usePromptContent(slot?.scope ?? '', slot?.name ?? '', slot ? shown : 0)
  const compareVersion = compare.startsWith('v') ? Number(compare.slice(1)) : 0
  const other = usePromptContent(slot?.scope ?? '', slot?.name ?? '', slot ? compareVersion : 0)
  const slotDrafts = (drafts.data?.items ?? []).filter((d) => slotKey(d.scope, d.name) === key)
  const compareDraft = slotDrafts.find((d) => d.id === compare)
  const compareText = compareDraft?.content ?? other.data?.content

  if (slots.isPending) return <div className="spinner" aria-label="Загрузка" />
  if (slots.isError || !slots.data) return <p className="error-box">Не удалось загрузить промпты.</p>

  return (
    <div>
      <p className="muted">
        Промпты лежат в репозитории версиями; в проде работает версия из настроек сервера. Правки сохраняются здесь
        черновиками, а новой версией становятся через PR: скажите в чате, какой черновик выкатить.
      </p>
      <div className={styles.slotTabs} role="radiogroup" aria-label="Промпт">
        {slots.data.slots.map((s) => {
          const k = slotKey(s.scope, s.name)
          return (
            <button
              key={k}
              role="radio"
              aria-checked={key === k}
              className={key === k ? styles.tabActive : styles.tab}
              onClick={() => {
                setKey(k)
                setVersion(0)
                setCompare('')
              }}
            >
              {SLOT_LABELS[k] ?? k}
            </button>
          )
        })}
      </div>

      {slot && (
        <div className="card-panel">
          <div className={styles.controls}>
            <label>
              Версия
              <Select
                aria-label="Версия"
                value={`v${shown}`}
                options={slot.versions.map((v) => ({
                  value: `v${v}`,
                  label: `v${v}${v === slot.active ? ' · сейчас в проде' : ''}`,
                  short: `v${v}`,
                }))}
                onChange={(v) => setVersion(Number(v.slice(1)))}
              />
            </label>
            <label>
              Сравнить с
              <Select
                aria-label="Сравнить с"
                className={styles.wide}
                value={compare}
                options={[
                  { value: '', label: 'не сравнивать' },
                  ...slot.versions.filter((v) => v !== shown).map((v) => ({ value: `v${v}`, label: `v${v}` })),
                  ...slotDrafts.map((d) => ({ value: d.id, label: `черновик: ${d.title || `от v${d.base_version}`}` })),
                ]}
                onChange={setCompare}
              />
            </label>
          </div>
          {base.isPending && <div className="spinner" aria-label="Загрузка" />}
          {base.data && compare && compareText !== undefined && (
            <PromptDiff
              before={base.data.content}
              after={compareText}
              labels={[`v${shown}`, compareDraft ? `черновик «${compareDraft.title || `от v${compareDraft.base_version}`}»` : compare]}
            />
          )}
          {base.data && !compare && <pre className={styles.promptText}>{base.data.content}</pre>}
        </div>
      )}

      {slot?.editable && base.data && (
        <PromptDrafts slot={slot} drafts={slotDrafts} viewedVersion={shown} viewedContent={base.data.content} />
      )}
    </div>
  )
}
